import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import { deleteLoggedInUserDetails } from "./LoggedInUserProvider";
import { userManager } from "./userManager";
import { generateLink } from "@/frontend/@navigation/routes";
import { useNavigate } from "@/frontend/@navigation/useNavigate";

export const useLogout = () => {
    const auth = useAuth();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return async () => {
        deleteLoggedInUserDetails();
        await auth.signoutRedirect({
            extraQueryParams: {
                client_id: userManager.settings.client_id,
                logout_uri: userManager.settings.redirect_uri
            }
        });
        queryClient.clear();
        void auth.signinRedirect();
        void navigate(generateLink("/", undefined, undefined));
    };
};
